import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Directive({
  selector: '[appCopyToClipboard]',
})
export class CopyToClipboardDirective {
  @Input() appCopyToClipboard: any;

  constructor(private ngElement: ElementRef, private renderer: Renderer2, private svApp: AppService) {}

  @HostListener('click', ['$event']) onClick(event: MouseEvent) {
    navigator.clipboard.writeText('' + this.appCopyToClipboard);
    this.svApp.alertCopyToClipboard$.next(true);
  }
}
